import { ref, onMounted, onUnmounted } from 'vue'

export function useScroll() {
  const isScrolled = ref(false)

  const onScroll = () => {
    isScrolled.value = window.scrollY > 0
  }

  onMounted(() => {
    window.addEventListener('scroll', onScroll)
    onScroll() // initialize on mount
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
  })

  return { isScrolled }
}



